import { FAST_API_URL, postOptions } from "../index";

export interface RealtimePublishJob {
    id: string;
    status: "queued" | "running" | "success" | "failed" | string;
    progress?: number;
    stage?: string | null;
    error?: string | null;
    attempt?: number;
    max_attempts?: number;
    updated_at?: string;
}

export interface RealtimeEditorFolderLanguage {
    subtitles_ready: boolean;
    audio_ready: boolean;
    video_ready: boolean;
    hls_published: boolean;
    revision: number;
    publish_job?: RealtimePublishJob | null;
}

export interface RealtimeEditorStatus {
    is_realtime_stream: boolean;
    media_id: string;
    language_from?: string;
    target_languages?: string[];
    folders: Array<{
        folder_num: number;
        source_ready: boolean;
        languages: Record<string, RealtimeEditorFolderLanguage>;
    }>;
}

const responseError = async (response: Response, fallback: string) => {
    try {
        const data = await response.json();
        return data?.detail || data?.message || fallback;
    } catch {
        return fallback;
    }
};

export const getRealtimeEditorStatusApi = async (mediaId: string): Promise<RealtimeEditorStatus> => {
    const response = await fetch(`${FAST_API_URL}/realtime_editor/status?media=${encodeURIComponent(mediaId)}`);
    if (!response.ok) {
        throw new Error(await responseError(response, "Failed to load realtime editor status"));
    }
    return await response.json();
};

export const publishRealtimeFolderHlsApi = async ({
    mediaId,
    folderNum,
    lang,
    languageFrom,
}: {
    mediaId: string;
    folderNum: number;
    lang: string;
    languageFrom: string;
}): Promise<{ job_id: string; status: string; progress?: number; stage?: string | null }> => {
    const response = await fetch(
        `${FAST_API_URL}/realtime_editor/publish?media=${encodeURIComponent(mediaId)}`,
        {
            ...postOptions,
            body: JSON.stringify({
                folder_num: folderNum,
                lang,
                language_from: languageFrom,
            }),
        },
    );
    if (!response.ok) {
        throw new Error(await responseError(response, "Failed to queue HLS publication"));
    }
    return await response.json();
};
